<template>
  <div class="after_add_to_cart_modal">
    <GenericModal
      unique-id="afterAddToCartModal"
      ref="afterAddToCartModal"
      :has-header="true"
      :has-footer="false"
      :max-width="'1199px'"
      :max-height="'360px'"
      :close-btn-color="'#ef1b1b'"
      :close-btn-position="'in'"
      :exit-modal-icon-font-size="'18px'"
      backgroundBlur="none"
      border-radius="0px"
      :border="'5px solid #48bebd'"
      @modal-closed="modalClosed()"
      @modal-opened="setAfterAddToCartRecommendationRequest(false)"
    >
      <template
        v-slot:header
      >
        <div class="prod_cart_modal_hdr">
          {{ t('after.add.to.cart.modal.header.title') }}
          <span class="cart_mod_descr">
            {{ t('after.add.to.cart.modal.header.description') }}
          </span>
        </div>
      </template>
      <div class="prod_cart_modal_slider_wrap">
        <div class="native_slider">
        <button class="native_slider-btn native_slider-btn-prev" data-scroll_left_by="-1" aria-label="Previous">Prev</button>
        <div class="native_slider-lg" data-drag_speed="2">
          <div v-for="(product, Idx) in liveData" :key="Idx" class="native_slider-li">
            <div class="modal_p_card">
            <div class="m_card_in">
              <div class="m_card_thumb_wrap">
                <div class="thumbnail_container">
                  <div class="thumbnail">
                    <a :href="productUrl(product)" :title="product.name">
                      <img
                        :width="280"
                        :height="280"
                        :alt="product.name"
                        :src="productMainImage(product)"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div class="modal_p_card_main">
                <div class="modal_p_card_title">
                  <a :href="productUrl(product)" :title="product.name">
                    {{ product.name.length > 90 ? product.name.substring(0, 90) + '...' : product.name }}
                  </a>
                </div>
                <div class="modal_p_card_info">
                  <div v-if="product.productHasDiscount" class="modal_p_card_disc">
                    {{ product.productDisclosure }}
                  </div>
                  <div v-if="product.productPoints > 0" class="m_card_points">
                    {{ product.productPoints }}
                    {{ product.productPoints === 1 ? t('after.add.to.cart.modal.point') : t('after.add.to.cart.modal.points') }}
                  </div>
                </div>
                <div class="modal_p_card_price">
                  <div v-if="product.productHasDiscount" >
                    <span class="modal_p_card_price_col og_price">
                      {{ (product.productOldPrice * getSelectedCurrency.rate).toFixed(2) }} {{ getSelectedCurrency.code }}
                    </span>
                    <span class="ml-auto modal_p_card_price_col price_final">
                       {{ (product.productFinalPrice * getSelectedCurrency.rate).toFixed(2) }} {{ getSelectedCurrency.code }}
                    </span>
                  </div>
                  <div v-else>
                    <span class="modal_p_card_price_col price_final f_w_price">
                       {{ (product.productFinalPrice * getSelectedCurrency.rate).toFixed(2) }} {{ getSelectedCurrency.code }}
                    </span>
                  </div>
                </div>
                <div class="modal_p_card_add">
                  <AdvButtonViewBuy
                    :show-quick-view="false"
                    :product-id="Number(product.product_id)"
                    :is-listing="true"
                    :is-variation-group-master="false"
                    :recommendation-id="product.recommendationId"
                    :recommendation-type="product.recommendationType">
                  </AdvButtonViewBuy>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
        <button class="native_slider-btn native_slider-btn-next" data-scroll_left_by="1" aria-label="Next">Next</button>
      </div>
      </div>
    </GenericModal>
  </div>
</template>

<script>

import GenericModal from './presentation/GenericModal'
import AdvButtonViewBuy from './AdvButtonViewBuy.vue'
import { mapActions, mapGetters } from 'vuex'
import firstMainProductImage from '../../vue/mixins/firstMainProductImage'

export default {
  name: 'AfterAddToCartModal',
  mixins: [firstMainProductImage],
  components: {
    GenericModal,
    AdvButtonViewBuy
  },
  watch: {
    afterAddToCartRecommendationOpenModal: function (newValue, oldValue) {
      if (newValue === false) {
        this.$refs.afterAddToCartModal.closeModal()
      }
    },
    liveData: {
      handler (value) {
        if (!value.length || this.modalIsOpen || !this.afterAddToCartRecommendationOpenModal) return
        this.$refs.afterAddToCartModal.openModal()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedCurrency',
      'getProductById',
      'afterAddToCartRecommendationProducts',
      'afterAddToCartRecommendationOpenModal'
    ]),
    modalIsOpen () {
      return this.$refs.afterAddToCartModal.isModalCurrentlyOpen
    },
    liveData () {
      const recommendations = this.afterAddToCartRecommendationProducts
      if (!recommendations) return []
      return recommendations.map((product) => {
        const productData = this.getProductById(Number(product.product_id))
        if (!productData) return null
        return {
          ...productData,
          ...product
        }
      }).filter((product) => product)
    }
  },
  methods: {
    ...mapActions([
      'setAfterAddToCartRecommendationRequest',
      'setAfterAddToCartRecommendationModal'
    ]),
    modalClosed () {
      this.setAfterAddToCartRecommendationModal(false)
      this.setAfterAddToCartRecommendationRequest(true)
    },
    productMainImage (product) {
      try {
        return this.firstMainProductImage(product).small
      } catch (e) {
        return '/ui/main/img/no_photo.jpg'
      }
    },
    buildQueryString (product) {
      if (product.recommendationType && product.recommendationId) {
        const urlParams = {};
        urlParams[window.advAppContext.advAppData.url.recommendationTypeQuerystring] = product.recommendationType
        urlParams[window.advAppContext.advAppData.url.recommendationIdQuerystring] = product.recommendationId
        return '?' + new URLSearchParams(urlParams).toString()
      }

      return ''
    },
    productUrl (product) {
      const queryString = this.buildQueryString(product)
      return product.productUrl + queryString
    }
  }
}
</script>

<style lang="scss" scoped>
.native_slider-lg{grid-auto-columns: calc(33.3333% - 12px); gap:15px;
  @media screen and (min-width:992px) and (max-width:1199px){
    grid-auto-columns: 40%
  }
  @media screen and (min-width:768px) and (max-width:991px){
    grid-auto-columns: 55%
  }
  @media screen and (min-width:651px) and (max-width:767px){
    grid-auto-columns: 65%
  }
  @media screen and (min-width:576px) and (max-width:650px){
    grid-auto-columns: 70%
  }
  @media screen and (max-width:575px){
    grid-template-columns: 100%; grid-auto-columns: 100%; grid-template-rows: repeat(4, 1fr); grid-column-gap: 0; grid-row-gap: 15px; grid-auto-flow: row
  }
}
.native_slider-btn{width:36px; height:36px; background-color: #fff; border-radius: 0; border:0; -webkit-box-shadow: none; box-shadow: none; background-position: center center; background-repeat: no-repeat; top:-60px; -webkit-transform: unset; transform: unset; opacity: .5;
  &:hover{opacity: 1}
  &-next{background-image: url(../img/slick-next-sm.png); right:0}
  &-prev{background-image: url(../img/slick-prev-sm.png); left:calc(100% - 80px)}
  @media screen and (max-width:575px){
    display: none!important
  }
}
</style>
